import { uuid } from 'uuidv4'
import { createClient } from '@slerp/client'
import { CREATE_MODIFIER_GROUP } from '../ModifierQueries'

interface CreateModifierGroupProps {
  name: string
  sku: string
  description: string
  minimum_enabled: boolean
  minimum: number
  maximum_enabled: boolean
  maximum: number
  modifierIds: string[]
  merchant_id: string
}

const CreateModifierGroup = async ({
  name,
  sku,
  description,
  minimum_enabled,
  minimum,
  maximum_enabled,
  maximum,
  modifierIds,
  merchant_id
}: CreateModifierGroupProps) => {
  const apiKey = localStorage.getItem('token') || ''
  const client = createClient(apiKey)

  const modifierGroupId = uuid()
  const modifierGroupModifiers = modifierIds.map((modifierId: string) => {
    return {
      id: uuid(),
      modifier_id: modifierId,
      modifier_group_id: modifierGroupId
    }
  })

  const variables = {
    id: modifierGroupId,
    name,
    sku,
    description,
    maximum,
    maximum_enabled,
    minimum,
    minimum_enabled,
    modifier_arrangement: { ...modifierIds },
    merchant_id,
    modifier_group_modifiers: [...modifierGroupModifiers]
  }

  return client.mutate({
    mutation: CREATE_MODIFIER_GROUP,
    variables
  })
}

export default CreateModifierGroup
